import React from 'react';
import { Box, CircularProgress, Typography, Container } from '@mui/material';

const LoadingScreen = () => {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundColor: '#F8F9FA',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Container maxWidth="sm">
                <Box
                    sx={{
                        textAlign: 'center',
                        padding: '40px 20px'
                    }}
                >
                    <CircularProgress 
                        size={60} 
                        thickness={4}
                        sx={{ 
                            color: '#0D6EFD',
                            marginBottom: '24px'
                        }} 
                    />
                    
                    <Typography 
                        variant="h6" 
                        sx={{ 
                            color: '#212529',
                            marginBottom: '12px',
                            fontWeight: 500
                        }}
                    >
                        Caricamento configurazione...
                    </Typography>
                    
                    <Typography 
                        variant="body2" 
                        sx={{ 
                            color: '#6C757D',
                            maxWidth: '300px',
                            margin: '0 auto'
                        }}
                    >
                        Stiamo configurando l'esperienza per il tuo dominio
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default LoadingScreen;